import { AnyAction } from 'redux';
import * as actions from 'store/healthTools/actions';
import { VideoData } from './types';

const defaultState: VideoData = {
  prediabetesVideosData: undefined,
  isFetching: false,
  error: undefined
};

const prediabetesVideosReducer = (state: VideoData = defaultState, action: AnyAction) => {
  switch (action.type) {
    case actions.GET_PREDIABETES_VIDEOS:
      return {
        ...state,
        isFetching: true,
        error: undefined
      };
    case actions.GET_PREDIABETES_VIDEOS_SUCCESS:
      return {
        ...state,
        prediabetesVideosData: action.payload.data,
        isFetching: false
      };
    case actions.GET_PREDIABETES_VIDEOS_FAIL:
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    default:
      return state;
  }
};

export default prediabetesVideosReducer;
